

import { createSelector } from "@reduxjs/toolkit";
export const confirmInviteCode = state => state.inviteReducer.confirmInviteCode;

